//@ts-nocheck
import { Box } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React from "react";
import { IRootStore } from "../stores";
import { LocationInfoForm as LocationInfo } from "../_new_/components/location-form-with-map/LocationForm";
import { CardContainer } from "./shared";
import { useSaveHook } from "./utils";

const LocationInfoEditPage: React.FC<{
  store: IRootStore;
  saveTutorInfo: (data: any) => Promise<any>;
  isLiteTutor?: boolean;
  liteLocation?: {
    country: string;
    state: string;
    region: string;
    regions: string[];
  };
}> = ({ store, saveTutorInfo, isLiteTutor, liteLocation }) => {
  const { loading, onSubmitSection } = useSaveHook(saveTutorInfo);

  async function onSubmit(formValues, geoData) {
    store.locationInfo.updateFields(formValues);
    const newData = {
      personalInfo: {
        ...store.personalInfo.formValues,
        ...store.locationInfo.formValues,
      },
      geoData,
    };
    return onSubmitSection(newData);
  }
  return (
    <Box>
      <CardContainer heading="Location Info">
        <LocationInfo
          loading={loading}
          countryOptions={store.locationInfo.countryOptions}
          defaultCountry="Nigeria"
          stateOptions={store.locationInfo.stateOptions}
          getCountryCode={store.locationInfo.getCountryCode}
          initialValues={
            {
              ...store.locationInfo.formValues,
            } as any
          }
          lessonTypeOptions={store.locationInfo.lessonTypeOptions.map((o) => ({
            label: o,
            value: o?.toLowerCase(),
          }))}
          inSupportedCountry={store.locationInfo.inSupportedCountry}
          regionOptions={store.locationInfo.regionOptions}
          supportedCountries={store.locationInfo.supportedCountries}
          supportedCountryAccount={store.locationInfo.supportedCountryAccount}
          displayMap
          onSubmit={onSubmit}
          isLiteTutor={isLiteTutor}
          liteLocation={liteLocation}
        />
      </CardContainer>
    </Box>
  );
};

export default observer(LocationInfoEditPage);
